// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { type StyledComponent } from '@emotion/styled';
import { token } from '@atlaskit/tokens';
import { grid, enlargedInputFieldHeight, inputFieldHeight } from '../style-utils';

import type { SearchCSS } from '../theme';
import {
	ClearIconWrapper,
	DesktopSearchIconWrapper,
	type IsExpandedProp,
	SearchInputField,
} from './search-input.styled';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import type { Theme } from '@emotion/react';
import type { ClassAttributes, HTMLAttributes, InputHTMLAttributes } from 'react';

// FIXME: convert-props-syntax rule doesn't catch this
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EnlargedDesktopSearchIconWrapper: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
	} & SearchCSS &
		IsExpandedProp &
		ClassAttributes<HTMLSpanElement> &
		HTMLAttributes<HTMLSpanElement> & {
			theme?: Theme;
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
		},
	{},
	{}
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled(DesktopSearchIconWrapper)<
	SearchCSS & IsExpandedProp
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
>((props) => ({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	width: props.isExpanded ? enlargedInputFieldHeight.half().px : grid.multiple(2).px,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	height: props.isExpanded ? enlargedInputFieldHeight.half().px : grid.multiple(2).px,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	top: props.isExpanded ? grid.multiple(1.5).px : grid.px,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	left: props.isExpanded ? grid.multiple(2).px : grid.px,
	display: 'flex',
	alignItems: 'center',
}));

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EnlargedClearIconWrapper: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
	} & SearchCSS &
		ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> & {
			theme?: Theme;
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression
		} & IsExpandedProp,
	{},
	{}
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled(ClearIconWrapper)<SearchCSS & IsExpandedProp>`
	width: ${token('space.300')};
	height: ${token('space.300')};
	padding-top: 0;
	padding-bottom: 0;
	padding-left: ${({ isExpanded }) => (isExpanded ? `${token('space.150')}` : '0')};
	padding-right: ${({ isExpanded }) => (isExpanded ? `${token('space.200')}` : '2px')};
	color: ${token('color.text.subtle')};
`;

// FIXME: convert-props-syntax rule doesn't catch this
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EnlargedSearchInputField: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
	} & SearchCSS &
		IsExpandedProp &
		ClassAttributes<HTMLInputElement> &
		InputHTMLAttributes<HTMLInputElement> & {
			theme?: Theme;
		},
	{},
	{}
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-dynamic-styles
> = styled(SearchInputField)<SearchCSS & IsExpandedProp>((props) => ({
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	height: props.isExpanded ? enlargedInputFieldHeight.px : inputFieldHeight.px,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	borderRadius: props.isExpanded ? token('radius.large') : token('radius.medium'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
	padding: props.isExpanded
		? `${token('space.150')} 52px ${token('space.150')} 52px`
		: `0px ${token('space.300')} 0px 30px`,
	'&:focus': {
		border: 'none',
		boxShadow: token('elevation.shadow.overlay'),
	},
}));
